import { Outlet, ScrollRestoration } from 'react-router';

import { usePortalBranding } from './brand/portal';
import { NavigationProgress } from './layout/NavigationProgress';

/** Top-level route element: navigation progress + scroll restoration around every page; applies the portal branding. */
export function RootLayout() {
  usePortalBranding();
  return (
    <>
      <NavigationProgress />
      <Outlet />
      <ScrollRestoration getKey={(location) => location.pathname} />
    </>
  );
}
